import { connect } from 'react-redux';
import { Divider } from 'rsuite';
import { RootState } from '../../../@types/RootState';
import { ReactComponent as Logo } from '../../../assets/logo/logo-infoprice-preto-azul.svg';
import { selectorNavBarData } from '../../../reducers/navBar/data';
import NavBarContentText from '../NavBarContentText/NavBarContentText';
import styles from './NavBarContent.module.scss';

const NavBarContent = ({ navBar }: ReturnType<typeof mapStateToProps>) => {
  return (
    <div className={styles['navbar-content']}>
      <Logo className={styles['logo']} />
      {navBar?.label && <Divider className={styles['divider']} vertical />}
      <NavBarContentText />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  navBar: selectorNavBarData(state),
});

export default connect(mapStateToProps)(NavBarContent);
